import 'swiper/swiper-bundle.css';

import { Button, Icon, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import qs from 'qs';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SwiperSlide } from 'swiper/react';

import { Swiper } from '@hero/atoms';
import { HomeTopCategoriesSkeletons } from '@hero/components/skeletons';
import { constants } from '@hero/configs';
import { ROUTE_PATHS } from '@hero/routes';

import * as S from './style';

export function HomeBrandSlider() {
  const navigationNextRef = useRef(null);
  const navigationPrevRef = useRef(null);
  const swiper = useRef();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isFetching = false;

  const params = {
    spaceBetween: 12,
    slidesPerView: 'auto',
    slidesPerGroup: 3,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 4
    }
  };

  return (
    <S.HomeBrandSliderWrapper>
      <S.HeaderWrapper>
        <Typography variant="subtitle1Bold">{t('exploreOurBrands')}</Typography>
        <VerticalDivider
          $margin="0 16px"
          $height="24px"
          color="var(--color-components-input-border-strong)"
        />
        <Button
          size="lg"
          variant="link"
          color="bg"
          onClick={() =>
            navigate(
              `${ROUTE_PATHS.GIFT_CATALOG}?${qs.stringify({
                categoryIds: ['1804']
              })}`
            )
          }
        >
          {t('seeAll')}
        </Button>
      </S.HeaderWrapper>
      <S.HomeBrandSlider>
        <S.NavigationButton color="secondary" variant="link" ref={navigationPrevRef}>
          <Icon name="left-chevron" size="lg" />
        </S.NavigationButton>

        {isFetching ? (
          <S.BrandSkeleton>
            <HomeTopCategoriesSkeletons />
          </S.BrandSkeleton>
        ) : (
          <Swiper
            ref={swiper}
            {...params}
            pagination={{
              clickable: true
            }}
          >
            {Object.values(constants?.brands?.data)
              ?.filter(brand => brand.useAsFilter || brand.isHomepageBrand)
              ?.map(brand => (
                <SwiperSlide
                  style={{
                    width: 160,
                    height: 280,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  key={brand.id}
                >
                  <S.BrandItem
                    onClick={() => {
                      if (brand.isHomepageBrand) {
                        return null;
                      }

                      navigate(
                        `${ROUTE_PATHS.GIFT_CATALOG}?${qs.stringify({
                          categoryIds: brand.categoryId
                        })}`
                      );
                    }}
                  >
                    <S.BrandImage
                      alt={brand.coverImgUrl}
                      src={brand.coverImgUrl}
                      height={140}
                      width={140}
                    />
                    <S.BrandLogo alt={brand.name} src={brand.logo} />
                  </S.BrandItem>
                </SwiperSlide>
              ))}
          </Swiper>
        )}
        <S.NavigationButton color="secondary" variant="link" ref={navigationNextRef}>
          <Icon name="right-chevron" size="lg" />
        </S.NavigationButton>
      </S.HomeBrandSlider>
    </S.HomeBrandSliderWrapper>
  );
}
